import { Component, ContentChild } from "@angular/core";

import { CardHeaderComponent } from "./card-header.component";

@Component({
  selector: "ta-card",
  templateUrl: "card.template.html"
})
export class CardComponent {
  @ContentChild(CardHeaderComponent, { static: true }) cardHeader: CardHeaderComponent;
}
